import React from "react";
import Carousel from "react-material-ui-carousel";
// import Rippleicon from '../Icon/Rippleicon'
import "./Carousel.css";
function Carouselcomp(props) {
  const { slides, setCurrentslide, currentslide } = props;
  return (
    <Carousel
      className="carousel"
      IndicatorIcon={<div className="line"></div>}
      activeIndicatorIconButtonProps={{ className: "active" }}
      interval={5000}
      onChange={(e) => setCurrentslide(e)}
    >
      {slides}
    </Carousel>
  );
}
export default Carouselcomp;
